// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"page-header-module--pageHeader--3SL0n","overlay":"page-header-module--overlay--sI7fg","title":"page-header-module--title--1fY0f"};